import { gql } from 'apollo-angular'

export default gql`
  query problems(
    $distinct_on: [problem_select_column!]
    $limit: Int
    $offset: Int
    $order_by: [problem_order_by!]
    $where: problem_bool_exp
  ) {
    problem(
      distinct_on: $distinct_on
      limit: $limit
      offset: $offset
      order_by: $order_by
      where: $where
    ) {
      id
      testDate
      scannerName
      facilityName
      facilityRoomName
      modalityName
      result
      scannerId
      commentsCount
      tableName
    }
    problem_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`
